import { Grid, Stack, Box } from "@mui/material";
import React from "react";
import { InternalUser } from "../../types/app";
import InternalUserAutocomplete from "../../shared/InternalUserAutocomplete";

interface IProps {
  salesReps: (InternalUser | null)[];
  setSalesReps: (value: React.SetStateAction<(InternalUser | null)[]>) => void;
  isDefaultRepsFromOrder?: boolean;
}

const SalesRepForm = ({ salesReps, setSalesReps }: IProps) => {
  const handleSetSalesRep = (index: number, rep: InternalUser | null) => {
    setSalesReps((prev) => {
      const newReps = [...prev];
      newReps[index] = rep;
      return newReps;
    });
  };

  return (
    <Grid container spacing={2} marginTop={6}>
      <Grid item xs={12}>
        <Stack direction="row" justifyContent="center">
          <Box width={"50%"}>
            <Stack spacing={4}>
              {salesReps.map((salesRep, index) => (
                <InternalUserAutocomplete
                  key={index}
                  value={salesRep}
                  onChange={(value) => handleSetSalesRep(index, value)}
                  label={`Sales Person ${index + 1}`}
                  limitToSalesReps
                />
              ))}
            </Stack>
          </Box>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default SalesRepForm;
